import { defineAsyncComponent } from 'vue'
export default {
  alternative: defineAsyncComponent(() => import("/app/packages/website-builder/app/layouts/alternative.vue").then(m => m.default || m)),
  dark: defineAsyncComponent(() => import("/app/packages/website-builder/app/layouts/dark.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/packages/website-builder/app/layouts/default.vue").then(m => m.default || m))
}